import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';
import React from 'react';

import dayjs from 'dayjs';
import { isNumOrStr } from '../../../../utils/isNumOrStr';
import { TooltipWrapper } from '../../utils/Utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultFormatter = (value: any): string =>
  isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1])
    ? value.join(' ~ ')
    : value;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Tooltip = (props: any): React.ReactElement => {
  const { payload, separator, formatter, itemStyle, itemSorter } = props;

  if (payload && payload.length) {
    const listStyle = { padding: 0, margin: 0 };

    const items = (itemSorter ? sortBy(payload, itemSorter) : payload).map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (entry: any, index: number): React.ReactElement => {
        if (entry.type === 'none') {
          return null;
        }
        const finalItemStyle = {
          display: 'block',
          color: 'var(--color-text)',
          ...itemStyle,
        };
        const finalFormatter = entry.formatter || formatter || defaultFormatter;
        let { name, value } = entry;

        if (finalFormatter) {
          const formatted = finalFormatter(value, name, entry, index);
          if (Array.isArray(formatted)) {
            [value, name] = formatted;
          } else {
            value = formatted;
          }
        }

        return (
          <React.Fragment key={`tooltip-item-${index}`}>
            <li className='recharts-tooltip-item' style={finalItemStyle}>
              {isNumOrStr(entry.name) ? (
                <span className='recharts-tooltip-item-name'>{entry.name}</span>
              ) : null}
              {isNumOrStr(entry.name) ? (
                <span className='recharts-tooltip-item-separator'>
                  {separator}
                </span>
              ) : null}
              <span className='recharts-tooltip-item-value'>{value}</span>
              <span className='recharts-tooltip-item-unit'></span>
            </li>
          </React.Fragment>
        );
      }
    );

    return (
      <TooltipWrapper>
        <ul className='recharts-tooltip-item-list' style={listStyle}>
          <TimeItem timestamp={payload[0].payload.Date} />
          {items}
        </ul>
      </TooltipWrapper>
    );
  }

  return null;
};

const TimeItem = ({ timestamp }: { timestamp: number }): React.ReactElement =>
  timestamp ? (
    <React.Fragment key='tooltip-item-00'>
      <li className='recharts-tooltip-item' style={{ display: 'block' }}>
        <span className='recharts-tooltip-item-name'>Date</span>
        <span className='recharts-tooltip-item-separator'> : </span>
        <span className='recharts-tooltip-item-value'>
          {tickFormatter(timestamp)}
        </span>
      </li>
    </React.Fragment>
  ) : null;

const tickFormatter = (tick: number): string =>
  tick > 12875256000
    ? dayjs.utc(Number(tick)).format('M/D/YY')
    : tick.toString();
